import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  required
} from 'react-admin';

const NotamsCreate: React.FC = (props: any) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput
          source='status'
          validate={[
            required()
          ]}
        />
        <TextInput
          source='body'
          fullWidth
          multiline
          validate={[
            required()
          ]}
        />
        <TextInput source='recvAt'
          validate={[
            required()
          ]}/>
        <TextInput source='sendAt'
          validate={[
            required()
          ]}/>
      </SimpleForm>
    </Create>
  );
};

export default NotamsCreate;
